/* El alta de una persona desde la barrera, con la llave `cargar.fleteros`.
 *
 * Igna, 22/10: portería puede dar de alta en el padrón a un FLETERO o a un
 * EXTERNO —nada más— y cada alta así le llega a Nico por mail (lo manda
 * FlotaBot). La regla la sostiene la base (política «portería da de alta
 * fleteros y externos» en `personas`, migración
 * `20261022190000_porteria_alta_fleteros.sql`); acá se arma el formulario para
 * que no ofrezca nada que la base va a rechazar.
 *
 * ── EN EL PADRÓN NO HAY UN VÍNCULO «FLETERO» ─────────────────────────────────
 *
 * `personas.tipo` es EMPLEADO / PROVEEDOR / EXTERNO, y EXTERNO dice
 * «(fleteros, contratistas)». Al fletero lo marca la especialización FLETERO
 * con puesto CHOFER: así están los 77 cargados y eso es lo que lee
 * `getChoferesFleteros`. Por eso la barrera elige entre dos palabras que
 * entiende —fletero o externo— y acá se traducen a las tres columnas.
 */

export const LLAVE_ALTA_PORTERIA = "cargar.fleteros";

/* ¿El formulario de persona se abre acotado a fletero/externo?
 *
 * Sólo cuando la llave nueva es lo ÚNICO que deja escribir en el padrón. Quien
 * además tiene `cargar.gente` o `cargar.rrhh` da altas completas desde hace
 * meses, y acotarlo sería sacarle algo que nadie decidió sacarle.
 * `null` (permisos todavía no llegaron) = sin acotar: es lo que ya hacía. */
export const altaSoloFleterosYExternos = (permisos) =>
  Array.isArray(permisos) &&
  permisos.includes(LLAVE_ALTA_PORTERIA) &&
  !permisos.includes("cargar.gente") &&
  !permisos.includes("cargar.rrhh");

export const VINCULOS_PORTERIA = [
  {
    value: "FLETERO",
    label: "Fletero (maneja un camión que no es de la empresa)",
    columnas: { tipo: "EXTERNO", puesto: "CHOFER", especializacion: "FLETERO" },
  },
  {
    value: "EXTERNO",
    label: "Externo (contratista, visita, otro)",
    columnas: { tipo: "EXTERNO", puesto: "", especializacion: "" },
  },
];

/* Las tres columnas para el vínculo elegido. Uno desconocido no cae en el
 * primero: devuelve `null`, y el formulario lo trata como «falta elegir». */
export const columnasDelVinculo = (vinculo) =>
  VINCULOS_PORTERIA.find((v) => v.value === vinculo)?.columnas || null;

/* Lo que pregunta el alta de la barrera: quién es y cómo ubicarlo. Lo de
 * RRHH (empresa propia, legajo, sueldos, base) no va: es de un empleado, y la
 * base lo rechazaría. `tipo`, `puesto` y `especializacion` viajan como
 * `secret` —no se dibujan— y se completan desde el vínculo. */
const DE_PERSONAS = ["id", "apellido", "nombres", "telefono", "ubicacion"];

export const camposAltaPorteria = (camposPersonas) => {
  const por = Object.fromEntries(camposPersonas.map((c) => [c.key, c]));
  const oculto = (key) => ({ ...por[key], type: "secret", inputType: "" });
  return [
    ...DE_PERSONAS.map((k) => por[k]).filter(Boolean),
    {
      key: "vinculo", label: "¿Qué es?", grupo: "Quién es", type: "principal",
      use: "form", dato: "clave", inputType: "inputOptions",
      optionsList: "vinculosPorteria", important: true,
    },
    oculto("tipo"),
    oculto("puesto"),
    oculto("especializacion"),
    // «De qué empresa viene» va acá: la columna `empresa` es la propia.
    { ...por.detalle, label: "Detalle (de qué empresa viene, patente, a qué vino)" },
  ];
};

export const opcionesVinculo = () =>
  VINCULOS_PORTERIA.map(({ value, label }) => ({ value, label }));
